import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IUser } from '../../../@core/models/model';
import { UserAvatarPipe } from '../../pipes/user-avatar-pipe';
import { FullNamePipe } from '../../pipes/fullName.pipe';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-avatar-stack',
    standalone: true,
    imports: [CommonModule, UserAvatarPipe, FullNamePipe, AvatarModule, AvatarGroupModule, TooltipModule],
    templateUrl: './avatar-stack.component.html',
    styleUrl: './avatar-stack.component.scss'
})
export class AvatarStackComponent {
    @Input() users: IUser[] | Partial<IUser>[] = [];
    @Input() visibleAvatars: number = 3;
    @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';

    get visibleUsers(): (IUser | Partial<IUser>)[] {
        return this.users.slice(0, this.visibleAvatars);
    }

    get remainingCount(): number {
        return Math.max(0, this.users.length - this.visibleAvatars);
    }

    get avatarSize(): string {
        const sizeMap = {
            'xs': 'w-6 h-6',
            'sm': 'w-8 h-8',
            'md': 'w-10 h-10',
            'lg': 'w-12 h-12'
        };
        return sizeMap[this.size];
    }

    trackByUser(index: number, user: IUser | Partial<IUser>): string {
        return user.id || user._id || index.toString();
    }

    getUserInitials(user: IUser | Partial<IUser>): string {
        const firstName = user.firstName || '';
        const lastName = user.lastName || '';
        return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    }


}
